"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.9999 29.4792C25.4126 29.4738 25.8069 29.3074 26.0988 29.0156C26.3907 28.7237 26.557 28.3294 26.5624 27.9167L26.5624 16.3542C26.5624 15.9398 26.3978 15.5423 26.1048 15.2493C25.8117 14.9563 25.4143 14.7917 24.9999 14.7917C24.5855 14.7917 24.1881 14.9563 23.8951 15.2493C23.602 15.5423 23.4374 15.9398 23.4374 16.3542L23.4374 27.9167C23.4428 28.3294 23.6092 28.7237 23.901 29.0156C24.1929 29.3074 24.5872 29.4738 24.9999 29.4792Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.9999 32.4167C24.6941 32.4167 24.3952 32.5077 24.1413 32.678C23.8873 32.8483 23.6898 33.0904 23.5737 33.3733C23.4577 33.6562 23.4284 33.9672 23.4896 34.2668C23.5508 34.5665 23.6997 34.8411 23.9174 35.0558C24.1351 35.2706 24.4117 35.4158 24.7121 35.4729C25.0125 35.53 25.3231 35.4965 25.6045 35.3766C25.8858 35.2567 26.1251 35.0559 26.292 34.7996C26.4588 34.5434 26.5457 34.2433 26.5416 33.9375C26.5361 33.5322 26.3713 33.1454 26.0827 32.8608C25.7942 32.5762 25.4052 32.4166 24.9999 32.4167Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.9999 45.8333C29.1204 45.8333 33.1483 44.6115 36.5743 42.3223C40.0003 40.0331 42.6706 36.7794 44.2474 32.9726C45.8242 29.1658 46.2368 24.9769 45.4329 20.9356C44.6291 16.8944 42.6449 13.1822 39.7313 10.2686C36.8177 7.35502 33.1056 5.37083 29.0643 4.56697C25.023 3.76311 20.8341 4.17568 17.0273 5.75251C13.2205 7.32934 9.96683 9.9996 7.67763 13.4256C5.38844 16.8516 4.16658 20.8796 4.16658 25C4.16658 27.7359 4.70545 30.445 5.75242 32.9726C6.79939 35.5002 8.33397 37.7968 10.2685 39.7314C12.2031 41.6659 14.4997 43.2005 17.0273 44.2475C19.555 45.2945 22.264 45.8333 24.9999 45.8333ZM24.9999 7.37501C28.4958 7.37501 31.9131 8.41221 34.8193 10.3553C37.7255 12.2984 39.9898 15.06 41.3257 18.2906C42.6616 21.5212 43.0091 25.0755 42.324 28.5036C41.639 31.9317 39.9522 35.0796 37.4773 37.5486C35.0024 40.0177 31.8506 41.697 28.4209 42.3739C24.9912 43.0509 21.4377 42.6951 18.2102 41.3515C14.9828 40.008 12.2266 37.7371 10.2903 34.8264C8.35412 31.9157 7.325 28.4959 7.33325 25C7.33325 20.3145 9.19455 15.8209 12.5077 12.5078C15.8208 9.19464 20.3144 7.33334 24.9999 7.33334L24.9999 7.37501Z",
    fill: fill
  }));
};

exports["default"] = _default;